/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.ComponentCQChooser";
        class ComponentCQChooser extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config, callback = null) {
                super(core, container, parent);
                this._config = null;
                // UI Components
                this._compressSelector = false; // If true, we just show a select drop-down, otherwise go full list
                this._loader = null;
                this._dlContainer = null;
                this._minDisplayDiv = null;
                this._noRecords = null;
                this._selectHolder = null;
                this._preselectQuery = null;
                this._cqDataList = null;
                this._optionInput = null;
                this._cqOptions = null;
                // Data state
                this._includeList = [];
                this._excludeList = [];
                this._queries = [];
                this._selectedQuery = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("CQChooserComponent._storeHtml()");
                    ComponentCQChooser.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._loadCustomQueries = (forceRefresh = true) => {
                    this._log.info("CQChooserComponent._loadCustomQueries()");
                    this._core.Functions.showElement(this._loader);
                    this._core.OBHelper.LoadCustomQueries(this._receiveCustomQueries);
                };
                this._receiveCustomQueries = () => {
                    this._log.info("CQChooserComponent._receiveCustomQueries()");
                    this._core.Functions.hideElement(this._loader);
                    this._queries = [];
                    if (this._core.OBHelper.CustomQueries.length > 0) {
                        for (let i = 0; i < this._core.OBHelper.CustomQueries.length; i++) {
                            let q = this._core.OBHelper.CustomQueries[i];
                            if (q.HideFromList)
                                continue;
                            if ((this._includeList.length > 0) && (this._includeList.indexOf(q.Name) == -1))
                                continue;
                            if ((this._excludeList.length > 0) && (this._excludeList.indexOf(q.Name) != -1))
                                continue;
                            this._queries.push(q);
                        }
                    }
                    if (this._queries.length > 0) {
                        this._updateDisplay();
                    }
                    else {
                        this._core.Functions.showElement(this._noRecords);
                        this._core.Functions.hideElement(this._minDisplayDiv);
                        this._core.Functions.hideElement(this._dlContainer);
                    }
                };
                this._updateDisplay = () => {
                    this._log.info("CQChooserComponent._updateDisplay()");
                    if (this._queries.length <= 0) {
                        this._core.Functions.showElement(this._noRecords);
                        this._core.Functions.hideElement(this._minDisplayDiv);
                        this._core.Functions.hideElement(this._dlContainer);
                        return;
                    }
                    this._core.Functions.hideElement(this._noRecords);
                    this._core.Functions.hideElement(this._minDisplayDiv);
                    this._core.Functions.hideElement(this._dlContainer);
                    let preSelectId = null;
                    this._cqOptions = { Items: [] };
                    if (this._compressSelector) {
                        this._cqOptions.Items.push({ Id: '-1', DisplayName: '' });
                    }
                    this._queries.forEach(query => {
                        this._cqOptions.Items.push({ Id: query.Id.toString(), DisplayName: query.Label });
                        if ((this._preselectQuery) && (this._preselectQuery == query.Name))
                            preSelectId = query.Id.toString();
                    });
                    // Depend on our overall setting for minimal or extended display
                    if (this._compressSelector) {
                        this._log.info("CQChooserComponent display is minimal");
                        this._optionInput.Options = this._cqOptions;
                        this._core.Functions.showElement(this._minDisplayDiv);
                        if (preSelectId) {
                            let preselectedQuery = this._cqOptions.Items.find(cq => cq.Id == preSelectId);
                            this._optionInput.Input.value = preselectedQuery.DisplayName;
                            this._typeSelectedFromSelect(null);
                        }
                    }
                    else {
                        this._log.info("CQChooserComponent display is normal");
                        // Full display
                        this._cqDataList.clearList();
                        this._cqDataList.displayData(this._cqOptions);
                        this._core.Functions.showElement(this._dlContainer);
                        if (preSelectId)
                            this._typeSelectedFromDataList(preSelectId);
                    }
                };
                this._typeSelectedFromDataList = (id) => {
                    this._log.info("CQChooserComponent._typeSelectedFromUList()");
                    let cqId = Number(id);
                    let query = this._queries.find(q => q.Id == cqId);
                    this._selectedQuery = query;
                    this._log.info(`CQChooserComponent._typeSelectedFromUList selected ${query.Name}`);
                    if (this._cqDataList.SelectedItems.indexOf(id) == -1) {
                        this._cqDataList.clearItemSelection();
                        this._cqDataList.selectItem(id);
                    }
                    if (this._selectCallBack)
                        this._selectCallBack(query);
                };
                this._typeSelectedFromSelect = (event) => {
                    this._log.info("CQChooserComponent._typeSelectedFromSelect()");
                    let returnedQuery = null;
                    let displayValue = this._optionInput.Input.value;
                    if (displayValue) {
                        let selectedQuery = this._cqOptions.Items.find(cq => cq.DisplayName == displayValue);
                        if (selectedQuery) {
                            returnedQuery = this._queries.find(q => q.Id == Number(selectedQuery.Id));
                        }
                    }
                    if (returnedQuery) {
                        this._selectedQuery = returnedQuery;
                        this._log.info(`CQChooserComponent._typeSelectedFromSelect selected ${returnedQuery.Name}`);
                        if (this._selectCallBack)
                            this._selectCallBack(returnedQuery);
                    }
                };
                this.selectCompressedUIMode = (compressed) => {
                    this._log.info("CQChooserComponent.selectCompressedUIMode()");
                    if (compressed != this._compressSelector) {
                        this._compressSelector = compressed;
                        this._updateDisplay();
                    }
                };
                this.setSelectionCallback = (callback) => {
                    this._log.info("CQChooserComponent.setSelectionCallback()");
                    this._selectCallBack = callback;
                };
                this.getSelectedQuery = () => {
                    this._log.info("CQChooserComponent.getSelectedQuery()");
                    return this._selectedQuery;
                };
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("CQChooserComponent.constructor()");
                // Configuration moved from base class so we can type it correctly
                this._config = config;
                if (this._config.hasOwnProperty('CompressSelector') && (this._config.CompressSelector))
                    this._compressSelector = this._config.CompressSelector;
                if (this._config.hasOwnProperty('PreselectQuery') && (this._config.PreselectQuery))
                    this._preselectQuery = this._config.PreselectQuery;
                if (this._config.hasOwnProperty('IncludeQueries') && (this._config.IncludeQueries))
                    this._includeList = this._config.IncludeQueries;
                if (this._config.hasOwnProperty('ExcludeQueries') && (this._config.ExcludeQueries))
                    this._excludeList = this._config.ExcludeQueries;
                if (callback)
                    this._selectCallBack = callback;
                // But the html is static
                if (!ComponentCQChooser.Html) {
                    core.Loader.getVersionedHTML('widgets/components/cqchooser.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            get SelectedQuery() {
                if (this._cqDataList.SelectedItems.length > 0) {
                    let cqId = Number(this._cqDataList.SelectedItems[0]);
                    let query = this._queries.find(q => q.Id == cqId);
                    return query;
                }
                return null;
            }
            _present() {
                this._log.info("CQChooserComponent._present()");
                if (!this._readyToPresent) {
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentCQChooser.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noRecords = this._container.querySelector('#cqComponentNoRecords');
                this._minDisplayDiv = this._container.querySelector('#cqSelectOnlyDisplay');
                this._dlContainer = this._container.querySelector('#cqComponentDataListContainer');
                this._selectHolder = this._container.querySelector('#cqMinimumUISelectHolder');
                this._core.Helper.prepareHourglassIcon(this._loader);
                this._core.Helper.setElementTranslation(this._container.querySelector('#cqComponentNoRecordsLabel'), 'STR_WPT_NO_QUERIES_AVAILABLE');
                this._core.Helper.setElementTranslation(this._container.querySelector('#cqComponentQueryListLabel'), 'STR_WPT_CUSTOM_QUERY');
                this._core.Helper.setElementTranslation(this._container.querySelector('#cqComponentLoading'), 'STR_WPT_LOADING');
                this._cqDataList = new Widgets.ComponentDataList(this._core, this._dlContainer, this._parent, { SelectItemCallback: this._typeSelectedFromDataList });
                this._cqDataList.present();
                this._cqOptions = {
                    Items: []
                };
                let optionConfig = {
                    Options: this._cqOptions,
                    ValueMustExist: true,
                    ChangeCallback: this._typeSelectedFromSelect
                };
                this._optionInput = new Widgets.ComponentOptionInput(this._core, this._selectHolder, this._parent, optionConfig);
                this._optionInput.present();
                this._optionInput.Input.id = "cqMinimumUISelect";
                this._loadCustomQueries();
            }
        }
        ComponentCQChooser.Html = null;
        Widgets.ComponentCQChooser = ComponentCQChooser;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
